const nowHours = (new Date()).getHours()
const isEvening = (nowHours >= 18 || nowHours <= 8)

const ThemeConfig = {
  daytimeBgURL: '//account.youku.com/static-resources/images/stylize/youku_bg.jpg',
  eveningBgURL: '//account.youku.com/static-resources/images/stylize/yknight.jpg',
  eveningFontColor: '#fff',
  daytimeFontColor: '#333'
}

// 登录默认配置项目
const DefaultLoginOptions = {
  loginOrLogout: 'login',
  callbackURL: '',
  mode: 'popup',
  template: 'tempA',
  buid: 'youku',
  pid: '8fb8456183734a86bfc1c15a1c761cdf',
  themes: ['148AFF', 'c0e8f6'],
  bgThemes: '#fff url(' + (isEvening ? ThemeConfig.eveningBgURL : ThemeConfig.daytimeBgURL) + ') no-repeat right bottom',
  fontColor: isEvening ? ThemeConfig.eveningFontColor : ThemeConfig.daytimeFontColor,
  inkColor: isEvening ? ThemeConfig.eveningFontColor : ThemeConfig.daytimeFontColor,
  padding: [30, 30, 30, 410], // padding设置，适应背景图片大小
  loginModel: ['normal', 'mobile'], // 需要展示的模板,默认界面放在第一位normal/mobile
  regModel: ['mobile'], // mobile/email
  isQRlogin: true,
  isThirdPartLogin: true,
  regShowType: 'in', // 注册展示方式 in：本页面展示，out：跳转注册页
  regRules: ['用户协议', '//mapp.youku.com/service/agreement', '//mapp.youku.com/service/copyright'], // 协议名称，协议地址，[版权声明(可为空)]
  qrMsg: '请使用优酷APP扫码登录', // 扫码登录的文字提示
  qrBu: ['ykt', 80, 'false'], // 二维码展示中logo的来源方，大小，是否居上
  size: 'normal',
  checkNoLogin: () => {}, // 检查数据项目
  loadSucess: () => {}, // 加载成功回调
  loginSuccess: () => {} // 登录成功回调
}

export {
  DefaultLoginOptions,
  ThemeConfig
}
